<script setup lang="ts">
  import { computed } from 'vue';
  import { Textarea } from '@/shared/ui';
  import { JUSTIFICATION_MAX_LENGTH } from '../model/const';

  withDefaults(defineProps<{ placeholder?: string }>(), {
    placeholder: 'Explique porque o documento foi reprovado',
  });

  const justification = defineModel<string>({ default: '' });

  const currentLength = computed(() => (justification.value ?? '').length);
</script>

<template>
  <div
    class="p-6"
    data-testid="rejection-justification-section"
  >
    <div class="text-gray-07 text-sm/5 w-full text-left font-semibold mb-2">
      Justifique:
    </div>
    <Textarea
      v-model="justification"
      :placeholder="placeholder"
      class="h-33.5 field-sizing-fixed resize-none"
      :maxlength="JUSTIFICATION_MAX_LENGTH"
    />
    <p class="text-xs text-gray-07">
      {{ currentLength }}/{{ JUSTIFICATION_MAX_LENGTH }} caracteres
    </p>
  </div>
</template>
